export const tr = {
    recommendation: 'Öneriler'
};
